// list here all supported plugins
import device from './plugins/cordova-plugin-device';

export default {
    install: (Vue, options) => {

        // declare global Vue.cordova object
        Vue.cordova = Vue.cordova ||
        {
            deviceready: false,
            plugins: []
        };

        // Cordova events wrapper
        Vue.cordova.on = (eventName, cb) => {
            document.addEventListener(eventName, cb, false);
        };

        // let Vue know that deviceready has been triggered
        document.addEventListener('deviceready',
            () => {
                Vue.cordova.deviceready = true;
            },
            false);

        device.install(Vue,
            options,
            pluginLoaded => {
                if (pluginLoaded) {
                    Vue.cordova.plugins.push(device);
                }
            });
    }
};



// WEBPACK FOOTER //
// ./src/utils/vue-cordova/index.js